module.exports = __webpack_public_path__ + "img/product_index_icon1.44e42e20.png";